import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ClientModal from 'components/ClientModal';
import {
  setGlobalClientModalSavedTrigger,
  setGlobalClientModalClosedTrigger,
} from 'store/container/globalClientModal/globalClientModal-slice';
import useUrlSearchParams from 'utils/useUrlSearchParams';
import useRequestSource from 'utils/useRequestSource';

const GlobalClientModal = () => {
  const search = useUrlSearchParams();

  useRequestSource('GlobalClientModal', !!search.get('client_uuid'));

  const history = useHistory();

  const dispatch = useDispatch();

  const uuid = search.get('client_uuid');

  return (
    <ClientModal
      uuid={uuid}
      onSaved={(data) => {
        dispatch(setGlobalClientModalSavedTrigger());
        if (uuid === 'create') {
          history.push(`?client_uuid=${data.uuid}`);
        }
      }}
      onClose={() => {
        history.push(history.location.pathname);
        dispatch(setGlobalClientModalClosedTrigger());
      }}
    />
  );
};

export default GlobalClientModal;
